import React, { useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import { useFirstMountState } from "react-use"
import useGlobalState from "../helpers/useGlobalState"
import Spinner from "../Spinner"
import Card from "./Card"
import CartTotal from "./CartTotal"
import ModalErrorServer from "../ModalErrorServer"

function ModalCart() {
  const [isLoadingCart, setIsLoadingCart] = useState(false)
  const isCheckoutPage = !!document.querySelector(".checkout-page")
  const isFirstRender = useFirstMountState()
  const [globalCart, setGlobalCart] = useGlobalState(window.globalCart)
  const { cartItems } = globalCart
  const lang = { ...globalCart.common, ...globalCart.summary }
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)

  useEffect(() => {
    if (isFirstRender) {
      setIsLoadingCart(true)
    }
    if (globalCart.isLoading !== null) {
      setIsLoadingCart(globalCart.isLoading)
      setIsErrorModalOpen(globalCart.discount.totals?.is_external_data_used === false && globalCart.cartItems.length > 0)
    }
  }, [globalCart])

  return (
    <>
      <CSSTransition
        in={isLoadingCart}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <Spinner />
      </CSSTransition>
      {globalCart.discount.totals?.total_sum_without_discount !== undefined &&
        globalCart.common !== undefined && (
          <div
            className={`modal modal--dbl-leaf modal-medium modal-cart ${
              cartItems.length === 0 ? "empty" : ""
            }`}
            data-target="modal-cart"
          >
            <div className="modal__zoom">
              <div className="modal-content modal-contect--narrow">
                <div className="flex">
                  <div className="modal-l-side">
                    <div className="close-btn js-close" />
                    <div className="modal__content">
                      <div className="modal__title">{lang.title}</div>
                      <div className="modal-content__empty">{lang.empty}</div>
                      <div className="modal-cart__added">
                        <span className="flex-c-c">{lang.element_added}</span>
                      </div>
                      <div className="scrolling-block cart-items">
                        {cartItems.map((item) => (
                          <Card
                            key={item.rowId}
                            lang={lang}
                            item={item}
                            setIsLoadingCart={setIsLoadingCart}
                          />
                        ))}
                      </div>

                      <div className="row_btn">
                        {isCheckoutPage ? (
                          <button className="wb-btn btn-green js-close">
                            {lang.do_order}
                          </button>
                        ) : (
                          <a href={lang.url_to_order} className="wb-btn btn-green">
                            {lang.do_order}
                          </a>
                        )}

                        <button className="wb-btn btn-white js-close">
                          {lang.continue_shop}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="modal-r-side">
                    <CartTotal
                      globalCart={globalCart}
                      labels={globalCart.common}
                      inTotalLabel={lang.in_total}
                    />
                    {lang.delivery_info ? (
                      <div className="info-row">
                        <p>{lang.delivery_info}</p>
                        <span className="icon">!</span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      {window.nextCartRequest &&
        lang.external_data_error &&
        globalCart.discount.totals?.is_external_data_used !== undefined && (
          <ModalErrorServer
            isOpen={isErrorModalOpen && !isLoadingCart}
            phrases={lang.external_data_error}
            setIsErrorModalOpen={setIsErrorModalOpen}
            unmountOnExit
          />
        )}
    </>
  )
}

// ModalCart.propTypes = {};

export default ModalCart
